import { Grid, TableCell, TableRow } from "@mui/material";
import React, { useEffect } from "react";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import TableDesign from "../../../../components/common/table/TableDesign";
import { TableHeading } from "../../customerInvoice/customerInvoiceUntil";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getAllSubContractorAction } from "../../../../store/reducers/subContractor";
import ManageSubContractor from "./ManageSubContractor";
import { capitalizeWords } from "../../../../hooks/helper";

const SubContractorList = ({ selectedId, setSelectedId,filterOption, setFilterOption }: any) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const {
    subContractors,
    pagination,
    isDeleteResponseSuccess,
    isAddSubContractorSuccess,
  } = useSelector((state: any) => state.subContractor);
  const handleOpen = () => setOpen(true);

  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Short Name", align: "left" },
    { label: "Email", align: "left" },
  ];

  useEffect(() => {
    if (subContractors.length > 0 && !selectedId) {
      setSelectedId(subContractors[0].id); // auto-select first staff
    }
    setOpen(false);
  }, [
    subContractors,
    selectedId,
    isDeleteResponseSuccess,
    isAddSubContractorSuccess,
  ]);

  return (
    <>
      {open && (
        <ManageSubContractor
          open={open}
          onHide={() => setOpen(false)}
          title="Add Sub Contractor"
          selectedRow={null}
          action="add"
        />
      )}
      <Grid container sx={{ height: "100%" }}>
        <Grid
          item
          md={12}
          xs={12}
          id="userList"
          sx={{
            height: "100%",
            border: "1px solid #CFCFCF",
            borderRadius: "5px",
            padding: "8px",
            overflow: "hidden",
          }}
        >
          <PageTitle
            title="Sub Contractors"
            button="Add"
            onClick={handleOpen}
          />
          {/* <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 1,
              justifyContent: "space-around",
              backgroundColor: "#F9F9F9",
              padding: "0px",
              borderRadius: "5px",
            }}
          >
            {updatedFields?.map((filter, i) => (
              <FormField
                key={filter.id}
                onPaste={(e: any) => e.preventDefault()}
                {...{
                  ...filter,
                  value: filterOption ? filterOption[filter.id] : "",
                  inSingleGridForm: true,

                  variant: "outlined",

                  onChange: (e: any) => {
                    const value =
                      filter.type === "checkbox"
                        ? e.target.checked
                        : e.target.value;
                    setFilterOption({
                      ...filterOption,
                      [filter.id]: value,
                    });
                  },

                  isNonMarginTop: true,

                  InputProps: {
                    sx:
                      filter.type === "text" || filter.type === "password"
                        ? { height: "36px" }
                        : { padding: "10px 4px", height: "36px" },
                  },
                }}
              />
            ))}
          </Grid> */}
          <TableDesign
            tableHeadings={tableHeadings}
            pagination={pagination}
            filterOption={filterOption}
            stickyHeader={true}
            setFilterOption={setFilterOption}
            tableHeadColor="#E5F4F1"
            extraCSS={{
              height: "calc(100% - 100px)",
            }}
          >
            {subContractors.length > 0 ? (
              subContractors.map((val: any, idx: number) => (
                <TableRow
                  key={val?.id}
                  onClick={() => setSelectedId(val?.id)}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    backgroundColor:
                      selectedId === val?.id ? "#f0f0f0" : "transparent",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell>{capitalizeWords(val?.aka_name)}</TableCell>
                  <TableCell>{val?.email}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No data found.
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Grid>
      </Grid>
    </>
  );
};

export default SubContractorList;
